import {
  ClaimTypes,
  Determination,
} from 'services/ClaimscoreApiService/shared/types';

export type FiltersForm = {
  startDate?: string;
  endDate?: string;
  determinations?: Determination[];
  deductionCodes?: string[];
  claimTypes?: ClaimTypes[];
  unitRange?: [number, number];
  payoutRange?: [number, number];
  scoreRange?: [number, number];
};

export enum ExportType {
  Insight = 'insight',
  Raw = 'raw',
}

export type ExportsForm = {
  title?: string;
};

export enum DrawerType {
  'Filter',
  'Export',
  'ShareReport',
  'ScheduleReport',
  'Timeframe',
}
export enum PayoutDrawerType {
  'Payout',
  'ClassMembers',
  'Units',
}

export const clearFormValues: FiltersForm = {
  determinations: [],
  deductionCodes: [],
  claimTypes: [],
  unitRange: undefined,
  payoutRange: undefined,
  scoreRange: undefined,
};

export enum PermissionsType {
  Organization = 'organization',
  Case = 'case',
}

export enum AccountStatus {
  Active = 'active',
  Pending = 'pending_2fa',
  Denied = 'denied',
}
